import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { systemAPI } from '../../apis';
import { i18n } from '../../language';
import useForward from '../../utils/useForward';
import AutoCompleteMultiCheckbox from '../AutoCompleteMultiCheckbox';
import DiaLog from '../Dialog';

const ForwardPopup = ({ open, setOpen, notificationId, handleSearch }) => {
  const [roomType, setRoomType] = useState([]);
  const [errorMsg, setErrorMsg] = useState(false);
  const roomTypeList = useForward();
  const [roomTypeOpen, setRoomTypeOpen] = useState(false);

  let schema = Yup.array().min(1);

  useEffect(() => {
    if (open) {
      setRoomType([]);
      setErrorMsg(false);
    }
  }, [open]);

  const focusCheck = useCallback(
    async (props) => {
      try {
        const valid = await schema.isValid(props ?? roomType);
        if (valid) {
          setErrorMsg(false);
        } else {
          setErrorMsg(true);
        }
      } catch (e) {
        console.log(e);
      }
    },
    [roomType]
  );

  const forWardNotificationAPI = useCallback(async () => {
    try {
      const valid = await schema.isValid(roomType);
      if (valid) {
        setErrorMsg(false);
        await systemAPI.postForward({ roomType, notificationId });
        handleSearch();
        setOpen(false);
      } else {
        setErrorMsg(true);
      }
    } catch (err) {
      console.log('=========Forward error===========>', err);
    }
  }, [roomType, notificationId]);

  const handleSelect = (event) => {
    if (roomType.some((item) => item.value === 6)) {
      // 已经是"Not to send"
      (async () => {
        await focusCheck(_.filter(event, (item) => item.value !== 6));
      })();
      setRoomType(_.filter(event, (item) => item.value !== 6));
    } else if (_.some(event, (item) => item.value === 6)) {
      // 选择了"Not to send"
      setRoomTypeOpen(false);
      (async () => {
        await focusCheck([_.find(event, (item) => item.value === 6)]);
      })();
      setRoomType([_.find(event, (item) => item.value === 6)]);
    } else {
      (async () => {
        await focusCheck(event);
      })();
      setRoomType(event);
    }
  };

  return (
    <DiaLog
      open={open}
      id="Dialog-Forward"
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('NOTIFICATION_FORWARD_POPUP_CONFIRM')}
      title={i18n.t('NOTIFICATION_FORWARD_POPUP_TITLE')}
      handleCancel={() => setOpen(false)}
      handleClose={() => setOpen(false)}
      handleConfirm={forWardNotificationAPI}
    >
      <AutoCompleteMultiCheckbox
        id="Notification-Forward-select"
        height="3.5rem"
        style={{ marginTop: '1.5rem' }}
        value={roomType}
        itemList={roomTypeList}
        placeholder={i18n.t('NOTIFICATION_FORWARD')}
        onChange={handleSelect}
        onBlur={() => {
          (async () => {
            await focusCheck();
          })();
        }}
        errorMsg={errorMsg ? i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_GROUP') }) : null}
        open={roomTypeOpen}
        onOpen={() => setRoomTypeOpen(true)}
        onClose={() => setRoomTypeOpen(false)}
      />
    </DiaLog>
  );
};

export default ForwardPopup;
